export default __webpack_public_path__ + "static/media/slide.c387c93b.svg";